import { CalendarIcon } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"

function parseISODate(value) {
  if (!value) return undefined
  const date = new Date(`${value}T00:00:00`)
  return Number.isNaN(date.getTime()) ? undefined : date
}

function toISODate(date) {
  return date.toLocaleDateString("en-CA")
}

// A single-date picker wired to an ISO "yyyy-MM-dd" string, matching what
// our API expects for date fields (e.g. Booking#starts_on/#ends_on).
export default function DatePicker({ value, onChange, disabled, placeholder = "Pick a date", min, id }) {
  const selected = parseISODate(value)
  const minDate = parseISODate(min)

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          id={id}
          type="button"
          variant="outline"
          disabled={disabled}
          className="w-full justify-start font-normal"
        >
          <CalendarIcon />
          {selected
            ? selected.toLocaleDateString("en-AU", { weekday: "short", day: "numeric", month: "short", year: "numeric" })
            : <span className="text-muted-foreground">{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(date) => date && onChange(toISODate(date))}
          disabled={minDate ? { before: minDate } : undefined}
          autoFocus
        />
      </PopoverContent>
    </Popover>
  )
}
